import { useUserSubscriptionTierQuery } from "../../../api/features/user-subscription/useUserSubscriptionTier.query";
import { PaywallABTestVariant } from "../../../constants/paywallABTestVariant.enum";
import {
  BONUSX_SUBSCRIPTION_TIERS,
  GENERAL_SUBSCRIPTION_TO_BONUSX_SUBSCRIPTION_TIER_MAP,
} from "../../../legacy/services/user-subscription/enums/bonusx-subscription-tiers.enum";

export function usePaywallABTestVariant(): PaywallABTestVariant | null {
  const { currentUserTier } = useUserSubscriptionTierQuery();
  const normalizedTier = GENERAL_SUBSCRIPTION_TO_BONUSX_SUBSCRIPTION_TIER_MAP[currentUserTier];
  const isFreeUser = normalizedTier === BONUSX_SUBSCRIPTION_TIERS.FREE;

  if (!isFreeUser) {
    return null;
  }

  return PaywallABTestVariant.ELEVENLABS;
}
